"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _switch = _interopRequireDefault(require("britive-design-system/core/components/switch"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _select = _interopRequireDefault(require("britive-design-system/core/components/select"));

var _table = _interopRequireDefault(require("britive-design-system/core/components/table"));

var _tooltip = _interopRequireDefault(require("britive-design-system/core/components/tooltip"));

var _pill = _interopRequireDefault(require("britive-design-system/core/components/pill"));

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var _textarea = _interopRequireDefault(require("britive-design-system/core/components/textarea"));

var _textfield = _interopRequireDefault(require("britive-design-system/core/components/textfield"));

var _spinner = _interopRequireDefault(require("britive-design-system/core/components/spinner"));

var _snackbar = _interopRequireDefault(require("britive-design-system/core/components/snackbar"));

var _lodash = require("lodash");

var _deleteIcon = _interopRequireDefault(require("../../../assets/delete-icon.svg"));

var _itsmService = require("../../../services/itsm-service");

var _userService = require("../../../services/user-service");

var _constants = require("./constants");

var _infoIcon = _interopRequireDefault(require("../../../assets/infoIcon.svg"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.advanced-settings-main-container {\n  flex-grow: 1;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .advanced-settings-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .advanced-settings-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .advanced-settings-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .advanced-settings-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n\n.margin-top-32 {\n  margin-top: 2rem; }\n\n.margin-top-8 {\n  margin-top: 0.5rem; }\n\n.reset-button {\n  cursor: pointer;\n  color: #067fdb;\n  font-size: 1rem; }\n\n.info-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.3125rem; }\n  .info-icon img {\n    height: 1.125rem; }\n\n.info-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.3125rem; }\n  .info-icon img {\n    height: 1.125rem; }\n\n.info-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.3125rem; }\n  .info-icon img {\n    height: 1.125rem; }\n";
  var fileName = "compone_Settings";
  var element = document.querySelector("style[data-sass-component='compone_Settings']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var ITSM = function ITSM(_ref) {
  var _JSON$stringify5, _JSON$stringify6;

  var handleITSMChange = _ref.handleITSMChange,
      handleResetITSM = _ref.handleResetITSM,
      settingsResp = _ref.settingsResp,
      _ref$displayReset = _ref.displayReset,
      displayReset = _ref$displayReset === void 0 ? false : _ref$displayReset,
      showToast = _ref.showToast;

  var _useState = (0, _react.useState)(-1),
      _useState2 = _slicedToArray(_useState, 2),
      rowToBeEdited = _useState2[0],
      setRowToBeEdited = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFilterCriteriaOpen = _useState6[0],
      setIsFilterCriteriaOpen = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      filterCriteriaJSON = _useState8[0],
      setFilterCriteriaJSON = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = _slicedToArray(_useState9, 2),
      email = _useState10[0],
      setEmail = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = _slicedToArray(_useState11, 2),
      username = _useState12[0],
      setUsername = _useState12[1];

  var _useState13 = (0, _react.useState)(""),
      _useState14 = _slicedToArray(_useState13, 2),
      ticketID = _useState14[0],
      setTicketID = _useState14[1];

  var _useState15 = (0, _react.useState)(''),
      _useState16 = _slicedToArray(_useState15, 2),
      supportedTicketType = _useState16[0],
      setSupportedTicketType = _useState16[1];

  var _useState17 = (0, _react.useState)([]),
      _useState18 = _slicedToArray(_useState17, 2),
      ticketCategoriesList = _useState18[0],
      setTicketCategoriesList = _useState18[1];

  var _useState19 = (0, _react.useState)([]),
      _useState20 = _slicedToArray(_useState19, 2),
      connectionsList = _useState20[0],
      setConnectionsList = _useState20[1];

  var _useState21 = (0, _react.useState)([]),
      _useState22 = _slicedToArray(_useState21, 2),
      ticketTypeList = _useState22[0],
      setTicketTypeList = _useState22[1];

  var _useState23 = (0, _react.useState)({}),
      _useState24 = _slicedToArray(_useState23, 2),
      validationResult = _useState24[0],
      setValidationResult = _useState24[1];

  var _useState25 = (0, _react.useState)(false),
      _useState26 = _slicedToArray(_useState25, 2),
      errorInJSON = _useState26[0],
      setErrorInJSON = _useState26[1];

  var _useState27 = (0, _react.useState)(false),
      _useState28 = _slicedToArray(_useState27, 2),
      user = _useState28[0],
      setUser = _useState28[1];

  var _useState29 = (0, _react.useState)(true),
      _useState30 = _slicedToArray(_useState29, 2),
      showReset = _useState30[0],
      setShowReset = _useState30[1];

  var infoMessage = 'The filter criteria will be used to verify the ticket number provided by requester during the check-out and approval request. The {username} or {email} fields in the filter will be replaced by the respected email Id/username of the requester.';
  (0, _react.useEffect)(function () {
    handleFetchConnections();
    fetchUser();
  }, []);
  var filteredOptions = (0, _react.useMemo)(function () {
    return ticketTypeList === null || ticketTypeList === void 0 ? void 0 : ticketTypeList.filter(function (type) {
      return !(ticketCategoriesList !== null && ticketCategoriesList !== void 0 && ticketCategoriesList.some(function (category) {
        return (category === null || category === void 0 ? void 0 : category.supportedTicketType) === (type === null || type === void 0 ? void 0 : type.name);
      }));
    });
  }, [ticketTypeList, ticketCategoriesList]);
  (0, _react.useEffect)(function () {
    if (settingsResp !== null && settingsResp !== void 0 && settingsResp.isInherited) {
      setShowReset(false); // Hide reset button if isInherited is true
    }
  }, [settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.isInherited]);
  (0, _react.useEffect)(function () {
    setTicketCategoriesList(settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.itsmFilterCriteria);
  }, [settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.itsmFilterCriteria]);
  (0, _react.useEffect)(function () {
    var type = settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.connectionType;

    if (type) {
      handleFetchConnectionsTemplates(type);
    }
  }, [settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.connectionType]);

  var fetchUser = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response, _response$data, _response, message;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return (0, _userService.getUser)();

            case 4:
              response = _context.sent;
              setUser(response);
              _context.next = 13;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              _response = _context.t0.response;
              message = (_response === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || 'Something went wrong';
              showToast(message, 'error');

            case 13:
              _context.prev = 13;
              setIsLoading(false);
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 13, 16]]);
    }));

    return function fetchUser() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleFetchConnections = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var response, _response2$data, _response2, message;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);
              _context2.prev = 1;
              _context2.next = 4;
              return (0, _itsmService.fetchITSMConnectionsList)();

            case 4:
              response = _context2.sent;
              setConnectionsList(response);
              _context2.next = 13;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              _response2 = _context2.t0.response;
              message = (_response2 === null || _response2 === void 0 ? void 0 : (_response2$data = _response2.data) === null || _response2$data === void 0 ? void 0 : _response2$data.message) || 'Something went wrong';
              showToast(message, 'error');

            case 13:
              _context2.prev = 13;
              setIsLoading(false);
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8, 13, 16]]);
    }));

    return function handleFetchConnections() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleFetchConnectionsTemplates = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(connectionType) {
      var response, _response3$data, _response3, message;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setIsLoading(true);
              _context3.prev = 1;
              _context3.next = 4;
              return (0, _itsmService.fetchConnectionsTemplates)(connectionType);

            case 4:
              response = _context3.sent;
              setTicketTypeList(response === null || response === void 0 ? void 0 : response.supportedTicketTypes);
              _context3.next = 13;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              _response3 = _context3.t0.response;
              message = (_response3 === null || _response3 === void 0 ? void 0 : (_response3$data = _response3.data) === null || _response3$data === void 0 ? void 0 : _response3$data.message) || 'Something went wrong';
              showToast(message, 'error');

            case 13:
              _context3.prev = 13;
              setIsLoading(false);
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 8, 13, 16]]);
    }));

    return function handleFetchConnectionsTemplates(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (rowToBeEdited >= 0) {
      var data = ticketCategoriesList[rowToBeEdited];
      setFilterCriteriaJSON(JSON.stringify(data === null || data === void 0 ? void 0 : data.filter, null, 2));
      setSupportedTicketType(data === null || data === void 0 ? void 0 : data.supportedTicketType);
      setIsFilterCriteriaOpen(true);
    }
  }, [rowToBeEdited]);
  var columns = [{
    field: 'key',
    headerName: 'Ticket Types Categories',
    width: '330px',
    renderColumn: function renderColumn(row) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell"
      }, /*#__PURE__*/_react.default.createElement(_pill.default, {
        readOnly: true,
        label: _constants.ticketTypes[row === null || row === void 0 ? void 0 : row.supportedTicketType],
        key: row === null || row === void 0 ? void 0 : row.supportedTicketType
      }));
    }
  }, {
    headerName: 'Filter Criteria',
    renderColumn: function renderColumn(row, value, index) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell-autocomplete"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        size: "medium",
        variant: 'secondary',
        onClick: function onClick() {
          setRowToBeEdited(index);
          setEmail(user === null || user === void 0 ? void 0 : user.email);
          setUsername(user === null || user === void 0 ? void 0 : user.username);
        }
      }, 'View Filter')));
    }
  }, {
    headerName: 'Action',
    renderColumn: function renderColumn(row, value, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell"
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: "Delete",
        position: "top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "action-button",
        onClick: function onClick() {
          return rowToBeDeleted(index);
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _deleteIcon.default
      }))));
    }
  }];
  var columnsForNewRow = [{
    width: '330px',
    // eslint-disable-next-line react/display-name
    renderColumn: function renderColumn() {
      return /*#__PURE__*/_react.default.createElement(_select.default, {
        placeholder: 'Select Type',
        width: '300px',
        value: _constants.ticketTypes[supportedTicketType] || '',
        onChange: function onChange(_, value) {
          setSupportedTicketType(value === null || value === void 0 ? void 0 : value.name);
          setFilterCriteriaJSON(JSON.stringify(value === null || value === void 0 ? void 0 : value.defaultFilter, null, 2));
        },
        options: filteredOptions || [],
        getOptionLabel: function getOptionLabel(option) {
          return (option === null || option === void 0 ? void 0 : option.displayName) || option;
        }
      });
    }
  }, {
    // eslint-disable-next-line react/display-name
    renderColumn: function renderColumn() {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          gap: '20px'
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        size: "medium",
        variant: 'secondary',
        onClick: function onClick() {
          setIsFilterCriteriaOpen(true);
          setEmail(user === null || user === void 0 ? void 0 : user.email);
          setUsername(user === null || user === void 0 ? void 0 : user.username);
        },
        disabled: (0, _lodash.isEmpty)(supportedTicketType)
      }, 'Add Filter'));
    }
  }];

  var rowToBeDeleted = function rowToBeDeleted(indexToDelete) {
    // Create a copy of the ticketCategoriesList array
    var updatedList = _toConsumableArray(ticketCategoriesList);

    if (indexToDelete > -1 && indexToDelete < updatedList.length) {
      updatedList.splice(indexToDelete, 1);
    } // Handle the ITSM change with the updated list


    setShowReset(true);
    handleITSMChange({
      itsmFilterCriteria: updatedList,
      settingsType: "ITSM",
      isInherited: false
    });
  };

  var closeModal = function closeModal() {
    // resetting everything to initial state
    setIsFilterCriteriaOpen(false);
    setFilterCriteriaJSON('');
    setEmail('');
    setUsername('');
    setTicketID('');
    setSupportedTicketType('');
    setRowToBeEdited(-1);
    setValidationResult({});
  };

  var validateJSON = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _JSON$stringify, _JSON$stringify2, _JSON$stringify3, _JSON$stringify4;

      var reqBody, response, _response4$data, _response4, message;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!((0, _lodash.isEmpty)(filterCriteriaJSON) || !isJSONValid())) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              setIsLoading(true);
              reqBody = _objectSpread({
                connectionId: settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.connectionId,
                ticketType: supportedTicketType,
                filter: JSON.parse(filterCriteriaJSON),
                ticketId: ticketID
              }, (_JSON$stringify = JSON.stringify(filterCriteriaJSON)) !== null && _JSON$stringify !== void 0 && _JSON$stringify.includes("{email}") || (_JSON$stringify2 = JSON.stringify(filterCriteriaJSON)) !== null && _JSON$stringify2 !== void 0 && _JSON$stringify2.includes("{username}") ? {
                variableMap: _objectSpread(_objectSpread({}, ((_JSON$stringify3 = JSON.stringify(filterCriteriaJSON)) === null || _JSON$stringify3 === void 0 ? void 0 : _JSON$stringify3.includes("{email}")) && {
                  email: email
                }), ((_JSON$stringify4 = JSON.stringify(filterCriteriaJSON)) === null || _JSON$stringify4 === void 0 ? void 0 : _JSON$stringify4.includes("{username}")) && {
                  username: username
                })
              } : {});
              _context4.prev = 4;
              _context4.next = 7;
              return (0, _itsmService.validateFilter)(reqBody);

            case 7:
              response = _context4.sent;
              setValidationResult(response);
              _context4.next = 16;
              break;

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](4);
              _response4 = _context4.t0.response;
              message = (_response4 === null || _response4 === void 0 ? void 0 : (_response4$data = _response4.data) === null || _response4$data === void 0 ? void 0 : _response4$data.message) || 'Something went wrong';
              setValidationResult({
                success: false,
                message: message
              });

            case 16:
              _context4.prev = 16;
              setIsLoading(false);
              return _context4.finish(16);

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[4, 11, 16, 19]]);
    }));

    return function validateJSON() {
      return _ref8.apply(this, arguments);
    };
  }();

  var isJSONValid = function isJSONValid() {
    if (!(0, _lodash.isEmpty)(filterCriteriaJSON)) {
      try {
        JSON.parse(filterCriteriaJSON);
        setErrorInJSON(false); // Set valid if JSON is correct

        return true;
      } catch (error) {
        setErrorInJSON(true); // Set invalid if JSON is incorrect

        return false;
      }
    } else {
      // If text area is empty, consider it valid
      setErrorInJSON(false);
      return true;
    }
  };

  var saveFilterData = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var newFilterCriteria, updatedList;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              newFilterCriteria = {
                supportedTicketType: supportedTicketType,
                filter: JSON.parse(filterCriteriaJSON)
              };
              updatedList = _toConsumableArray(ticketCategoriesList || []);

              if (rowToBeEdited >= 0 && rowToBeEdited < updatedList.length) {
                updatedList[rowToBeEdited] = newFilterCriteria;
              } else {
                updatedList.push(newFilterCriteria);
              }

              setShowReset(true);
              handleITSMChange({
                itsmFilterCriteria: updatedList,
                settingsType: "ITSM",
                isInherited: false
              });
              closeModal();
              showToast('Filter Criteria saved successfully.', 'success');

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function saveFilterData() {
      return _ref10.apply(this, arguments);
    };
  }();

  var ITSMModalButtons = [{
    text: 'Save',
    onClick: saveFilterData,
    size: 'medium',
    disabled: !(validationResult !== null && validationResult !== void 0 && validationResult.success)
  }, {
    text: 'Cancel',
    variant: 'secondary',
    onClick: closeModal,
    size: 'medium'
  }];

  var getNameById = function getNameById() {
    if (!(0, _lodash.isEmpty)(connectionsList)) {
      var id = settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.connectionId;
      var foundObject = connectionsList.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.id) === id;
      });
      return (foundObject === null || foundObject === void 0 ? void 0 : foundObject.name) || '';
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "medium",
    message: "Loading",
    overlay: true
  }), /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "heading5"
  }, 'ITSM Settings ', (settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.isInherited) && '(Inherited)  ', displayReset && showReset && /*#__PURE__*/_react.default.createElement("span", {
    className: _constants.classes.resetButton,
    onClick: function onClick() {
      setShowReset(false);
      handleResetITSM();
    }
  }, (0, _utils.isPolicyPath)() ? "Reset to Profile" : (0, _utils.isProfilePath)() ? 'Reset to Application' : 'Reset to Default')), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", 'Enable ITSM integration for Checkout and Approval Requests', " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_switch.default, {
    label: settingsResp !== null && settingsResp !== void 0 && settingsResp.isITSMEnabled ? 'Enabled' : 'Disabled',
    checked: (settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.isITSMEnabled) || false,
    onToggle: function onToggle(checked) {
      setShowReset(true);
      handleITSMChange({
        isITSMEnabled: !checked,
        settingsType: "ITSM",
        isInherited: false
      });
      setSupportedTicketType('');
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_select.default, {
    label: 'Select ITSM Connection',
    width: '300px',
    value: getNameById() || '',
    onChange: function onChange(_, value) {
      setShowReset(true);
      setSupportedTicketType('');
      handleITSMChange({
        connectionType: value === null || value === void 0 ? void 0 : value.type,
        connectionId: value === null || value === void 0 ? void 0 : value.id,
        itsmFilterCriteria: [],
        settingsType: "ITSM",
        isInherited: false
      });
    },
    options: connectionsList,
    getOptionLabel: function getOptionLabel(option) {
      var name = (option === null || option === void 0 ? void 0 : option.name) || option;
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", 'Type', " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, " ", _constants.connectionTypeName[settingsResp === null || settingsResp === void 0 ? void 0 : settingsResp.connectionType] || 'None', " "))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_table.default, {
    resizableColumns: true,
    columns: columns || [],
    rows: ticketCategoriesList || [],
    addNewRow: true,
    columnsForNewRow: columnsForNewRow
  })), isFilterCriteriaOpen && /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: 500,
    title: "Filter Criteria",
    onCancel: closeModal,
    buttons: ITSMModalButtons
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _lodash.isEmpty)(validationResult) && !(validationResult !== null && validationResult !== void 0 && validationResult.success) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_snackbar.default, {
    errorList: [validationResult === null || validationResult === void 0 ? void 0 : validationResult.message]
  }), /*#__PURE__*/_react.default.createElement("br", null)), /*#__PURE__*/_react.default.createElement(_textarea.default, {
    type: "text",
    label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Enter Filter Criteria JSON", /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: infoMessage,
      position: "bottom"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.infoIcon
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _infoIcon.default
    })))),
    value: filterCriteriaJSON,
    onChange: function onChange(e) {
      setFilterCriteriaJSON(e.target.value);
      setErrorInJSON(false);
      setValidationResult({});
    },
    error: errorInJSON,
    errorMsg: 'Entered text in filter is not valid JSON'
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, 'Enter Email/Username and Ticket ID to Validate JSON. Filter Criteria cannot be saved until the validation is true.'), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", 'Type', " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, " ", _constants.ticketTypes[supportedTicketType] || 'None', " ")), ((_JSON$stringify5 = JSON.stringify(filterCriteriaJSON)) === null || _JSON$stringify5 === void 0 ? void 0 : _JSON$stringify5.includes("{email}")) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_textfield.default, {
    type: "text",
    label: 'Email',
    value: email,
    onChange: function onChange(e) {
      setValidationResult({});
      setEmail(e.target.value);
    }
  })), ((_JSON$stringify6 = JSON.stringify(filterCriteriaJSON)) === null || _JSON$stringify6 === void 0 ? void 0 : _JSON$stringify6.includes("{username}")) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_textfield.default, {
    type: "text",
    label: 'Username',
    value: username,
    onChange: function onChange(e) {
      setValidationResult({});
      setUsername(e.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_textfield.default, {
    type: "text",
    label: 'Ticket ID',
    value: ticketID,
    onChange: function onChange(e) {
      setValidationResult({});
      setTicketID(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_button.default, {
    size: "medium",
    variant: 'secondary',
    onClick: function onClick() {
      validateJSON();
    }
  }, !(0, _lodash.isEmpty)(validationResult) ? 'Re-validate' : 'Validate'), /*#__PURE__*/_react.default.createElement("br", null), (validationResult === null || validationResult === void 0 ? void 0 : validationResult.success) && /*#__PURE__*/_react.default.createElement(_textarea.default, {
    type: "text",
    height: "200px",
    label: 'Validation Result',
    value: JSON.stringify(validationResult, null, 2),
    readOnly: true
  }))));
};

ITSM.propTypes = {
  settingsResp: _propTypes.default.object,
  handleITSMChange: _propTypes.default.func.isRequired,
  handleResetITSM: _propTypes.default.func.isRequired,
  displayReset: _propTypes.default.bool,
  showToast: _propTypes.default.func
};
var _default = ITSM;
exports.default = _default;